import { motion } from 'framer-motion';
import { X } from 'lucide-react';
import { COPY } from './playlistCopy';

const TONES = {
  info: {
    box: 'from-primary-50 to-primary-100 dark:from-primary-900/20 dark:to-primary-800/10 border-primary-200/60 dark:border-primary-700/40',
    icon: 'text-primary-600 dark:text-primary-400',
    text: 'text-primary-900 dark:text-primary-100',
    hover: 'hover:bg-primary-200/60 dark:hover:bg-primary-700/30',
  },
  warning: {
    box: 'from-amber-50 to-amber-100 dark:from-amber-900/20 dark:to-amber-800/10 border-amber-200/60 dark:border-amber-700/40',
    icon: 'text-amber-600 dark:text-amber-400',
    text: 'text-amber-900 dark:text-amber-100',
    hover: 'hover:bg-amber-200/60 dark:hover:bg-amber-700/30',
  },
};

/** Same shape as SyncActivityBanner: icon, one line, ghost action, dismiss. */
export default function PlaylistBanner({ tone = 'info', Icon, children, actionLabel, onAction, onDismiss, testId }) {
  const t = TONES[tone];
  return (
    <motion.div
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -10 }}
      transition={{ duration: 0.25 }}
      data-testid={testId}
      className={`mb-6 squircle bg-gradient-to-r border px-4 py-3 ${t.box}`}
    >
      <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
        <Icon className={`w-5 h-5 flex-shrink-0 ${t.icon}`} strokeWidth={2} />
        <p className={`flex-1 basis-48 min-w-0 text-body-sm font-medium ${t.text}`}>{children}</p>
        {actionLabel && (
          <button
            type="button"
            onClick={onAction}
            className={`flex-shrink-0 ml-auto px-3 py-1.5 squircle-sm text-body-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 ${t.text} ${t.hover}`}
          >
            {actionLabel}
          </button>
        )}
        {onDismiss && (
          <button
            type="button"
            onClick={onDismiss}
            aria-label={COPY.dismiss}
            className={`flex-shrink-0 p-1.5 squircle-sm transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 ${t.icon} ${t.hover}`}
          >
            <X className="w-4 h-4" />
          </button>
        )}
      </div>
    </motion.div>
  );
}
